import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  isDev:boolean = false;
  constructor(private route: ActivatedRoute){
    this.route.queryParams.subscribe(params => {
      this.isDev = params['dev'];
    });
  }

  private featureFlags: { [key: string]: boolean } = environment.FEATURE_FLAG;

  isFeatureEnabled(featureName: string): boolean {
    return !!this.featureFlags[featureName];
  }

  // Method to toggle a feature at runtime
  toggleFeature(featureName: string): void {
    this.featureFlags[featureName] = !this.featureFlags[featureName];
  }

  isSuperAdmin(): boolean {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return currentUser?.email === 'sudarshan.chippa@pro-vigil.com';
  }
}